import { Diamond, Medicine, Tennis, Education } from "../../../shared/assets/svg";

export const prosData = [
    {
        icon: <Diamond />,
        title: <>Команда с&nbsp;уникальной экспертизой</>,
        description: (
            <>
                Мы&nbsp;стояли у&nbsp;истоков фондового рынка и&nbsp;продолжаем создавать для него инновационные
                решения. С&nbsp;нами вы&nbsp;сможете реализовать свои амбиции и&nbsp;повысить свой профессионализм.
            </>
        ),
    },
    {
        icon: <Tennis />,
        title: "Яркая корпоративная жизнь",
        description: (
            <>
                Мы&nbsp;компания динамичного роста и&nbsp;высоких показателей. Вас ждет среда для постоянного обучения
                и&nbsp;развития, командные выезды и&nbsp;тимбилдинги.
            </>
        ),
    },
    {
        icon: <Medicine />,
        title: <>Комфорт и&nbsp;забота о&nbsp;вас</>,
        description: (
            <>
                Расширенный ДМС, льготные условия банковского обслуживания, спортивные сообщества, праздники
                и&nbsp;подарки для детей сотрудников и&nbsp;другие возможности для вас.
            </>
        ),
    },
    {
        icon: <Education />,
        title: <>Корпоративное обучение и&nbsp;развития</>,
        description: <>Мы создаем условия для профессионального развития и карьерного роста. Возможность реализации как управленческого, так и экспертного трека развития, программы наставничества и менторинга от опытных коллег.</>,
    },
];

export const swiperMobileProps = {
    navigation: "down",
    navigationTheme: "light",
    colorBackground: "#E5E7E8",
} as const;
